<template>
    <div class="app--engagement-progress">
        <div class="bar" :style="{'width': width + '%'}">
            <span v-if="current <= count"><small>{{label}}</small>{{current}} {{labelOf}} {{total}}</span>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            current: {type: Number, required: true  },
            total:   {type: Number, required: true  },
            type:    {type: String, default: 'FORM' },
            trans:   {type: Object, default: () => ({})     },
        },
        computed: {
            label() {
                return this.trans && this.trans.label ? this.trans.label : this.$t('app.common.page')
            },
            labelOf() {
                return this.trans && this.trans.of ? this.trans.of : this.$t('app.common.of')
            },
            width() {
                return (this.current * 100) / this.count
            },
            count() {
                return this.type == 'PDF' ? this.total+1 : this.total
            }
        }
    }
</script>
